export default __webpack_public_path__ + "static/media/015-vase.0bf04ba3.svg";